import { render } from "./EmbeddedGenogramLegendView.vue?vue&type=template&id=1da24a9c"
import script from "./EmbeddedGenogramLegendView.vue?vue&type=script&lang=js"
export * from "./EmbeddedGenogramLegendView.vue?vue&type=script&lang=js"

import "./EmbeddedGenogramLegendView.vue?vue&type=style&index=0&id=1da24a9c&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__